import { resetTelegramScroll } from '@/utils/telegramWebAppClient'

/**
 * Reset scroll position for all common scroll roots (window, document, #app, Telegram WebView).
 */
export function resetPageScroll() {
  resetTelegramScroll()

  try {
    window.scrollTo(0, 0)
  } catch (_) {
    /* ignore */
  }

  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  } catch (_) {
    /* ignore */
  }

  if (document.documentElement) {
    document.documentElement.scrollTop = 0
  }
  if (document.body) {
    document.body.scrollTop = 0
  }

  const app = document.getElementById('app')
  if (app) {
    app.scrollTop = 0
  }
}
